import { z } from "zod";

//QualidadeProcessosRiscosSchema

const optionalString = z.coerce.number();

export const QualidadeProcessosRiscosSchema = z.object({
  IdProcessos: z.number().optional(),
  Ano: optionalString,
});

// QualidadeProcessosRiscosForm

export type QualidadeProcessosRiscosForm = z.infer<typeof QualidadeProcessosRiscosSchema>;